import { Toggle } from '@augmentt-dev/ui-components'
import PropTypes from 'prop-types'
import React, { useMemo, useState } from 'react'
import { useIntl } from 'react-intl'
import JsonView from '../../../../../components/JsonView'
import { intunePolicySettingsViewStyles as intuneSettingsStyles } from '../../intune/intune_common/IntunePolicySettingsView'
import { cleanPolicyObject } from '../../policy_management/utils'
import { POLICY_FRAME_LAYOUT } from '../FormattedPolicyFrame'
import PolicyDetailsFrame from '../PolicyDetailsFrame'
import PrettyView from './PrettyView'

const propTypes = {
  /**
   * Policy payload (raw policy) object
   */
  rawPolicy: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  /**
   * Form options map
   */
  policyFormOptionsMap: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  /**
   * Sanitize checkbox component
   */
  sanitizeCheck: PropTypes.node,
  /**
   * If true, hides header (title) and show toggle in line with content
   */
  headless: PropTypes.bool,
  /**
   * Inputs to hide in pretty view only
   */
  hiddenInputs: PropTypes.arrayOf(PropTypes.string),
  /**
   * `accordion` for policy details. Default `flat` keeps template view as open headings.
   */
  layout: PropTypes.oneOf(Object.values(POLICY_FRAME_LAYOUT)),
}

function JsonPrettyView(props) {
  const {
    rawPolicy = {},
    policyFormOptionsMap = {},
    sanitizeCheck = null,
    headless = false,
    hiddenInputs = [],
    layout = POLICY_FRAME_LAYOUT.FLAT,
  } = props ?? {}

  const intl = useIntl()

  const cleanPolicy = useMemo(() => cleanPolicyObject(rawPolicy), [rawPolicy])

  const [showJsonView, setShowJsonView] = useState(false)

  return (
    <PolicyDetailsFrame
      sanitizeCheck={sanitizeCheck}
      headless={headless}
      toggle={
        <Toggle
          id="toggleJsonView"
          className={intuneSettingsStyles.jsonViewToggle}
          labelTextStyle="font-size-default text-strong me-2 text-color-default"
          labelText={intl.formatMessage({ id: 'POLICY_TEMPLATES.JSON_VIEW' })}
          checked={showJsonView}
          onChange={setShowJsonView}
        />
      }
    >
      {showJsonView ? (
        <JsonView rawJson={cleanPolicy} colorize />
      ) : (
        <PrettyView
          policyFormOptionsMap={policyFormOptionsMap}
          rawPolicy={rawPolicy}
          hiddenInputs={hiddenInputs}
          layout={layout}
        />
      )}
    </PolicyDetailsFrame>
  )
}

JsonPrettyView.propTypes = propTypes

export default JsonPrettyView
